import { Box } from "../Box"

import { FlagImg } from "./FlagImg"

// hexagonal clip path
const clipPath = "polygon(50% 0%, 97% 25%, 97% 75%, 50% 100%, 3% 75%, 3% 25%)"

const Flag = ({ name, width, height, ratio, borderWidth }) => (
  <Box
    position={borderWidth ? "absolute" : "relative"}
    overflow="hidden"
    top={`${borderWidth}px`}
    left={`${borderWidth}px`}
    width={width.map(w => (typeof w === "number" ? `${w}px` : w))}
    height={height.map(h => (typeof h === "number" ? `${h}px` : h))}
    clipPath={clipPath}
  >
    <Box
      position="absolute"
      top={0}
      left="50%"
      transform="translateX(-50%)"
      width={width.map(w => (typeof w === "number" ? `${w * ratio}px` : w))}
    >
      <FlagImg name={name} />
    </Box>
  </Box>
)

export const FlagHex = ({
  name,
  width,
  height,
  borderWidth,
  borderColor,
  ratio,
}) => {
  if (borderWidth)
    return (
      <Box
        position="relative"
        overflow="hidden"
        width={width.map(w =>
          typeof w === "number" ? `${w + borderWidth * 2}px` : w
        )}
        height={height.map(h =>
          typeof h === "number" ? `${h + borderWidth * 2}px` : h
        )}
        clipPath={clipPath}
        bg={borderColor}
      >
        <Flag
          name={name}
          width={width}
          height={height}
          ratio={ratio}
          borderWidth={borderWidth}
        />
      </Box>
    )

  return (
    <Flag
      name={name}
      width={width}
      height={height}
      ratio={ratio}
      borderWidth={borderWidth}
    />
  )
}
